<template>
  <div
    v-if="userHasPermission(constants.PERMISSION_TYPES.PUDO_EXPIRY, constants.PERMISSION_VALUES.CREATE)"
    :class="{'spl-modal-holder-show': isVisible}"
    class="spl-modal-holder"
    @click.self="closeModal">
    <div class="spl-modal spl-upload-modal ">
      <div class="spl-modal__label">
        Expiry Action
      </div>
      <div>
        <form-label>Expiry Action</form-label>
        <form-filtered-select
          v-model="selectedAction"
          :options="currentExpiryOptions"
          :invalid="$v.selectedAction.$error"
          data-cy="expiry-modal-option"
          track-by="PUDO_Expiry_Option_ID"
          label="Description"
          @close="$v.selectedAction.$touch()" />
      </div>
      <br>
      <span v-if="$v.selectedAction.$error" class="error">You must select an expiry option</span>
      <div class="spl-modal__close" @click="closeModal" />
      <div class="row">
        <div class="col6">
          <form-button
            :wide="true"
            :secondary="true"
            @onClick="closeModal">Cancel</form-button>
        </div>
        <div class="col6">
          <form-button
            :wide="true"
            data-cy="expiry-modal-save"
            @onClick="submitModal()">Save</form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import constants from '@/constants'
import Helpers from '@/helpers.vue'
import { mapState, mapActions } from 'vuex'
import { required, minValue } from 'vuelidate/lib/validators'
export default {
  mixins: [Helpers],
  data () {
    return {
      isVisible: false,
      selectedAction: -1,
      constants
    }
  },
  computed: {
    ...mapState('pudo', ['currentExpiryOptions'])
  },
  validations: {
    selectedAction: {
      required,
      minValue: minValue(0)
    }
  },
  methods: {
    ...mapActions('pudo', ['saveExpiryAction']),
    openModal () {
      this.isVisible = true
    },
    submitModal () {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        this.$emit('expiryActionSaving')
        this.saveExpiryAction(this.selectedAction).then(() => {
          this.$toast('You successfully set the expiry action.', constants.defaultToastOptions())
          this.$emit('expiryActionSaved')
        }).catch(() => {
          this.$emit('expiryActionSaved')
        })
        this.isVisible = false
      }
    },
    // Close the scan window
    closeModal () {
      this.isVisible = false
    }
  }
}
</script>

<style>

</style>
